import React from 'react'
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { addDoc, collection } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { useState } from 'react';
import ReactPixel from "react-facebook-pixel" 

const Checkin = (props) => {
    const [number, setNumber] = useState("");
    const [Name, setName] = useState("");
    const [Email, setEmail] = useState("");
    const [Address, setAddress] = useState("");
    const [bought, setBought] = useState(false);
  
    // Firestore Reference
    const collectionRef = collection(db, "Probud");
  
 
  
    // Order Product Function
    const OrderProduct = async (e) => {
      try {
        // Prevent default if this is triggered by a form
        e?.preventDefault();
  
        // Update state
        setBought(true);
        props.setCartNo(props.cartNo + 1)
  
        // Add document to Firestore
        await addDoc(collectionRef, {
          Name: Name,
          Amount: 61000,
          Number: number,
          Product: "JBL flip 5",
          Address: Address,
          Paid: false,
          Email: Email
        });
        ReactPixel.track('AddToCart', {
            content_name: "JBL GO3",
            content_category: "Speakers",
            value: 61000,
            currency: 'NGN',
          });
  
        
        window.location.href = "https://wa.link/pssdvo";
      } catch (error) {
        console.error("Error adding document: ", error);
      }
    };
    // Validation Schema
    const schema = yup.object().shape({
      Name: yup.string().required("Name is required"),
      Email: yup.string().required("Name is required").email("must be an email"),
      Address: yup.string().required("Your address is required"),
      Number: yup
        .number()
        .typeError("Phone number must be a number")
        .required("Enter your phone number")
        .min(11)
        .max(11),
    });
  
    // Hook Form Setup
    const {
      register,
      handleSubmit,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
  
    // Handle Form Submission
    const onSubmit = (data) => {
      props.setName(data.Name);
      props.setAddress(data.Address);
      props.setNumber(data.Number);
      reset(); // Reset form after submission
    };
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-gray-100">
    {/* Main Card */}
    <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-lg">
      {/* Header */}
      <h1 className="text-3xl font-extrabold text-gray-800 text-center mb-6">
        Checkout Form
      </h1>
  
      <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
        {/* Name Input */}
        <div>
          <label htmlFor="name" className="block text-gray-700 font-medium mb-2">
            Name on Transfer
          </label>
          <input
            type="text"
            id="name"
            placeholder="Enter your name"
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            {...register("Name")}
            onChange={(e) => setName(e.target.value)}
          />
          <p className="text-red-600 text-sm mt-1">{errors.Name?.message}</p>
        </div>
  
        {/* Email Input */}
        <div>
          <label htmlFor="email" className="block text-gray-700 font-medium mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            placeholder="Enter your Email"
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            {...register("Email")}
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className="text-red-600 text-sm mt-1">{errors.Email?.message}</p>
        </div>
  
        {/* Address Input */}
        <div>
          <label htmlFor="address" className="block text-gray-700 font-medium mb-2">
            Address
          </label>
          <textarea
            id="address"
            placeholder="Enter your specific address"
            rows="3"
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            {...register("Address")}
            onChange={(e) => setAddress(e.target.value)}
          />
          <p className="text-red-600 text-sm mt-1">{errors.Address?.message}</p>
        </div>
  
        {/* Phone Number Input */}
        <div>
          <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">
            Phone Number
          </label>
          <input
            type="tel"
            id="phone"
            placeholder="Enter your phone number"
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            {...register("Number")}
            onChange={(e) => setNumber(e.target.value)}
          />
          <p className="text-red-600 text-sm mt-1">{errors.Number?.message}</p>
        </div>
  
        {/* Delivery Details */}
        <div className="bg-gray-50 p-4 rounded-lg shadow-inner border text-gray-700">
          <ul className="list-disc list-inside space-y-1">
            <li>Delivery within <span className="font-semibold">3-5 business days</span>.</li>
            <li>Free delivery on all orders.</li>
            <li>You will receive a tracking number via email to monitor your package.</li>
          </ul>
        </div>
  
        {/* Account Details */}
        <div className="mt-8">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Payment Instructions
          </h2>
          <div className="bg-blue-50 p-4 rounded-lg space-y-4 border">
            <div className="flex justify-between">
              <span>Account Number:</span>
              <span className="font-medium text-gray-900">8069529288</span>
            </div>
            <div className="flex justify-between">
              <span>Account Name:</span>
              <span className="font-medium text-gray-900">Ebere Alaga</span>
            </div>
            <div className="flex justify-between">
              <span>Bank Name:</span>
              <span className="font-medium text-gray-900">Opay</span>
            </div>
          </div>
          <p className="text-sm text-gray-500 mt-3 text-center">
            Please ensure all details are correct before making your transfer.
          </p>
        </div>
  
        {/* Submit Button */}
        <button
          type="submit"
          onClick={OrderProduct}
          className="w-full py-3 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300 ease-in-out"
        >
          Complete Transfer
        </button>
      </form>
    </div>
  </div>
  
  )
}

export default Checkin
